import {
    useNavigate,
} from "react-router-dom";

function QuickActions() {

    const navigate =
        useNavigate();

    return (

        <div style={styles.card}>

            <h2 style={styles.title}>
                Quick Actions
            </h2>

            <div style={styles.buttons}>

                <button
                    style={styles.primaryButton}
                    onClick={() =>
                        navigate("/search")
                    }
                >
                    Book Court
                </button>

                <button
                    style={styles.secondaryButton}
                    onClick={() =>
                        navigate("/bookings")
                    }
                >
                    Upcoming Bookings
                </button>

                <button
                    style={styles.secondaryButton}
                    onClick={() =>
                        navigate("/history")
                    }
                >
                    Order History
                </button>

            </div>

        </div>
    );
}

const styles = {

    card: {

        background:
            "rgba(0,40,70,0.72)",

        padding: "24px",

        borderRadius: "24px",

        border:
            "1px solid rgba(0,255,136,0.15)",
    },

    title: {

        margin: 0,

        marginBottom:
            "20px",

        color:
            "#fff",

        fontSize:
            "24px",

        fontWeight:
            "800",
    },

    buttons: {

        display: "flex",

        flexDirection: "column",

        gap: "14px",

        padding:
            "20px",
    },

    primaryButton: {

        padding: "16px",

        borderRadius: "16px",

        border: "none",

        background:
            "linear-gradient(90deg, #00ff88, #00d4ff)",

        fontWeight: "700",

        cursor: "pointer",
    },

    secondaryButton: {

        padding: "16px",

        borderRadius: "16px",

        border:
            "1px solid rgba(255,255,255,0.1)",

        background:
            "rgba(255,255,255,0.05)",

        color: "#fff",

        cursor: "pointer",
    },
};

export default QuickActions;